<mat-form-field appearance="fill">
    <mat-label *ngIf="label()">{{label()}}</mat-label>
    <textarea matInput placeholder="{{placeholder()}}" rows="{{rows()}}"  [formControl]="control"></textarea>

    <mat-error *ngIf="showError && control?.hasError('required')" [id]="''">Required</mat-error>
    <mat-error *ngIf="control?.hasError('message')" [id]="''">{{ control.getError('message') }}</mat-error>
</mat-form-field>